/**
 * 검색·공유가 읽는 글의 «수정일» 규칙 — sitemap `lastModified` 와 JSON-LD `dateModified` 가 함께 쓴다.
 *
 * ⛔ `updatedAt` 은 쓰지 않는다 — 기존 블로그 문서의 그 값은 마지막 조회 시각일 수 있다(조회수 갱신이 같이 쓰던 칸).
 */

/** 수정일을 고르는 데 쓰는 두 날짜 */
export type ContentDates = {
  createdAt?: Date | null;
  /** 본문을 고친 때 — 없으면 작성일이 수정일이다 */
  editedAt?: Date | null;
};

/**
 * @returns `editedAt` · 없으면 `createdAt` · 둘 다 없거나 깨진 날짜면 `null`
 */
export function contentModifiedAt({ createdAt, editedAt }: ContentDates): Date | null {
  return validDate(editedAt) ?? validDate(createdAt);
}

// ---- private ------------------------------------------------------------

function validDate(value: Date | null | undefined): Date | null {
  return value instanceof Date && Number.isFinite(value.getTime()) ? value : null;
}
